import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {DialogBody as UIDialogBody} from '@travel-frontend/ui-components';

export const DialogBody = styled(UIDialogBody)`
  ${({theme}) =>
    theme.respondTo(
      'md',
      css`
        max-height: 550px;
      `
    )}
`;
